module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOAQMAAAAc4Q7JAAAABlBMVEUAAACBh42iWzlpAAAAAXRSTlMAQObYZgAAABBJREFUCNdj+HwegYAANxcAvAkVGVjy4vwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_board_hover.png
// module id = edA8
// module chunks = 9